// Device names contain '(', ')' and '.', so a token has to be escaped before it becomes a pattern.
const escapeRegExp = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

// Vuetify highlights a match by slicing the title with these ranges, so they must come back sorted and non-overlapping.
const mergeRanges = (ranges) => {
  const merged = []
  for (const [start, end] of [...ranges].sort((a, b) => a[0] - b[0])) {
    const last = merged[merged.length - 1]
    if (last && start <= last[1]) last[1] = Math.max(last[1], end)
    else merged.push([start, end])
  }
  return merged
}

// Custom filter for the left bar's device picker. A device matches when EVERY whitespace-separated token appears
// somewhere in its description, case-insensitively — so 'cf1', 'CF1' and 'cf1 prod' all surface 'amb cf1 (Production)'.
// Returns -1 for "no match", true for "matches but nothing to highlight", or the ranges Vuetify highlights.
export const filterDeviceByDescription = (value, query) => {
  if (value == null || query == null) return -1

  // A whitespace-only query matches everything. Return true, not 0: Vuetify reads a number as a match *offset* and would
  // highlight the first query.length characters of every device name.
  const tokens = query.toString().split(/\s+/).filter(Boolean)
  if (!tokens.length) return true

  const description = value.toString()
  const ranges = []
  for (const token of tokens) {
    // Match against the original description rather than a lowercased copy: lowercasing can change a string's length
    // ('İ' becomes two code units), which shifts every offset after it and would highlight the wrong characters.
    const matches = [...description.matchAll(new RegExp(escapeRegExp(token), 'gi'))]
    if (!matches.length) return -1
    for (const match of matches) ranges.push([match.index, match.index + match[0].length])
  }
  return mergeRanges(ranges)
}
